export default {
  TRASH: 'trash',
  SET: 'set',
  PROJECTS: 'projects',
  LAYERS: 'layers',
  TAG: 'tag',
  DRAWER: 'drawer',
  MANUFACTURER: 'manufacturer',
  HEART: 'heart',
  // CATEGORIES: 'categories',
};
